import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Spring/LengthAndPerimeter/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'LengthAndPerimeter',
  field: 'Measurement',
  weeks: [4, 6],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/1MeasureInMetresAndCentimetres" */ './1MeasureInMetresAndCentimetres'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/2MeasureInMillimetres" */ './2MeasureInMillimetres'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/3MeasureInCentimetresAndMillimetres" */ './3MeasureInCentimetresAndMillimetres'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/4MetresCentimetresAndMillimetres" */ './4MetresCentimetresAndMillimetres'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/5EquivalentLengthsMetresAndCentimetres" */ './5EquivalentLengthsMetresAndCentimetres'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/6EquivalentLengthsCentimetresAndMillimetres" */ './6EquivalentLengthsCentimetresAndMillimetres'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/7CompareLengths" */ './7CompareLengths'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/8AddLengths" */ './8AddLengths'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/9SubtractLengths" */ './9SubtractLengths'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/10WhatIsPerimeter" */ './10WhatIsPerimeter'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/11MeasurePerimeter" */ './11MeasurePerimeter'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/LengthAndPerimeter/12CalculatePerimeter" */ './12CalculatePerimeter'
        )
    })
  ]
});
export default Block;
